"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _typeValidation = _interopRequireDefault(require("./typeValidation"));
var _rating = require("@citrus/rating");
var _PctyQuestion = require("./PctyQuestion.Common");
var PctyQuestionStarRating = function PctyQuestionStarRating(_ref) {
  var id = _ref.id,
    number = _ref.number,
    disabled = _ref.disabled,
    readOnly = _ref.readOnly,
    required = _ref.required,
    scenario = _ref.scenario,
    question = _ref.question,
    response = _ref.response,
    hint = _ref.hint,
    onResponse = _ref.onResponse,
    starCount = _ref.starCount,
    allowComments = _ref.allowComments,
    commentsPlaceholder = _ref.commentsPlaceholder,
    comment = _ref.comment,
    onComment = _ref.onComment;
  var onItemClick = function onItemClick(ratingValue) {
    if (readOnly) return;
    if (onResponse) onResponse(id, ratingValue);
  };
  var noResponseDisableComments = response == 0;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _PctyQuestion.renderHint)(id, hint), (0, _PctyQuestion.renderScenario)(id, scenario), (0, _PctyQuestion.renderQuestion)(id, number, question, required, readOnly), /*#__PURE__*/_react.default.createElement(_rating.StarRating, {
    number: starCount,
    id: id,
    className: "star-rating",
    onItemClick: onItemClick,
    disabled: disabled || readOnly,
    automationId: "question-".concat(number, "-StarRating"),
    value: response
  }), (0, _PctyQuestion.renderQuestionComment)(id, readOnly, allowComments, commentsPlaceholder, comment, onComment, noResponseDisableComments));
};
PctyQuestionStarRating.propTypes = {
  /** A hint that you want to give the person answering the question. */
  hint: _propTypes.default.string,
  /** The id for the component. */
  id: _propTypes.default.string.isRequired,
  /** The number of stars to display in the component. */
  starCount: _propTypes.default.number.isRequired,
  /** Whether or not the question will be disabled. */
  disabled: _propTypes.default.bool,
  /** Whether or not the question will be readOnly. */
  readOnly: _propTypes.default.bool,
  /** The question number. */
  number: _propTypes.default.number.isRequired,
  /** Whether or not the question will be displayed as required. */
  required: _propTypes.default.bool,
  /** Callback function that receives response information each time a someone interacts with the question. */
  onResponse: _propTypes.default.func.isRequired,
  /** The question text. */
  question: _propTypes.default.string.isRequired,
  /** An array of response objects that are output from the component. */
  response: _propTypes.default.number,
  /** Some text that sets up your question. */
  scenario: _propTypes.default.string,
  /** Whether or not the questions is setup for comments */
  allowComments: _propTypes.default.bool,
  /** The placeholder text for the comments textarea. */
  commentsPlaceholder: _propTypes.default.string,
  /** The value of the comment field associated to this question component. */
  comment: _propTypes.default.string,
  /** Callback function that received comment information each time someone interatacts with the comment. */
  onComment: _propTypes.default.func.isRequired,
  __TYPE: function __TYPE(props, propName, componentName) {
    return (0, _typeValidation.default)(props, propName, componentName, 'PctyQuestionStarRating');
  }
};
PctyQuestionStarRating.defaultProps = {
  scenario: null,
  starCount: 5,
  disabled: false,
  readOnly: false,
  __TYPE: 'PctyQuestionStarRating',
  allowComments: false
};
var _default = exports.default = PctyQuestionStarRating;